module.exports = __webpack_public_path__ + "static/ndcporto19-cb44fb97a19834b5e9335638d3b35866.jpeg";